import type { NotificationItem } from "@/lib/types";

/**
 * TUT-586b — as caixas do sino, a MESMA régua da API (`naCaixa`,
 * `apps/api/src/domain/adiar-aviso.ts`): sem caixa, a lista de todo dia (sem os
 * arquivados, e em "Não lidas" também sem os adiados para o futuro); "adiadas"
 * só os adiados para o futuro; "arquivadas" só os arquivados.
 */
export type CaixaDoSino = "adiadas" | "arquivadas";

/** Até quando adiar: 1 hora, amanhã às 8h ou a próxima segunda às 8h. */
export type AdiarAte = "1h" | "amanha" | "proxima-semana";

export const OPCOES_DE_ADIAR: readonly { ate: AdiarAte; rotulo: string }[] = [
  { ate: "1h", rotulo: "1 hora" },
  { ate: "amanha", rotulo: "Amanhã" },
  { ate: "proxima-semana", rotulo: "Próxima semana" },
];

export function adiadaAgora(item: Pick<NotificationItem, "snoozedUntil">, agora = new Date()): boolean {
  return Boolean(item.snoozedUntil && new Date(item.snoozedUntil).getTime() > agora.getTime());
}

export function naCaixa(
  item: Pick<NotificationItem, "snoozedUntil" | "archivedAt">,
  filtros: { caixa?: CaixaDoSino | undefined; unreadOnly?: boolean },
  agora = new Date(),
): boolean {
  if (filtros.caixa === "arquivadas") return Boolean(item.archivedAt);
  if (item.archivedAt) return false;
  if (filtros.caixa === "adiadas") return adiadaAgora(item, agora);
  return filtros.unreadOnly ? !adiadaAgora(item, agora) : true;
}

/**
 * A volta do adiamento NO NAVEGADOR — só para o modo demonstração, que não
 * tem servidor. A e2e e o demo rodam no fuso do escritório (TUT-410); a API
 * calcula no fuso do escritório de verdade.
 */
export function voltaDoAdiamentoNoNavegador(ate: AdiarAte, agora = new Date()): Date {
  if (ate === "1h") return new Date(agora.getTime() + 60 * 60 * 1000);
  const dias = ate === "amanha" ? 1 : (8 - agora.getDay()) % 7 || 7;
  return new Date(agora.getFullYear(), agora.getMonth(), agora.getDate() + dias, 8, 0);
}

const FORMATO_DA_VOLTA = new Intl.DateTimeFormat("pt-BR", {
  weekday: "short",
  day: "2-digit",
  month: "2-digit",
  hour: "2-digit",
  minute: "2-digit",
});

/** "seg., 09/11, 08:00" — a marca "Adiada · volta …" e o aviso do "Adiar". */
export function quandoVolta(iso: string): string {
  return FORMATO_DA_VOLTA.format(new Date(iso));
}
